module.exports = __webpack_public_path__ + "img/UTCORA.e5bd375b.png";